import React, { useState } from 'react';
import './HomieProducts.css';

// Product images
import flowersImage from '../../Product_Flower_01.png';
import prerollsImage from '../../Product_Pre-Rolls_01.png';
import vapeImage from '../../Product_VapeOil_01.png';
import mistImage from '../../Product_Mist_01.png';
import gummiesImage from '../../Product_Gummies_01.png';
import dreamiesImage from '../../Product_Dreamies_01.png';

interface Category {
  id: string;
  title: string;
  image: string;
}

const categories: Category[] = [
  { id: 'flowers', title: 'FLOWER', image: flowersImage },
  { id: 'pre-rolls', title: 'PRE-ROLL', image: prerollsImage },
  { id: 'vaporisers', title: 'VAPE', image: vapeImage },
  { id: 'mist', title: 'MIST', image: mistImage },
  { id: 'spots', title: 'SPOTS', image: gummiesImage }, // Placeholder
  { id: 'dreamies', title: 'DREAMIES', image: dreamiesImage },
];

const HomieProducts: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>('flowers');

  const currentCategory = categories.find(c => c.id === selectedCategory) || categories[0];
  const selectedIndex = categories.findIndex(c => c.id === selectedCategory);

  const getTabClassName = (index: number): string => {
    const isActive = index === selectedIndex;
    if (isActive) {
      return 'homie-products__tab homie-products__tab--active';
    }
    return 'homie-products__tab homie-products__tab--inactive';
  };

  return (
    <section className="homie-products">
      <div className="homie-products__content">
        <h2 className="homie-products__title">OUR PRODUCTS</h2>
        <div className="homie-products__divider" />
        <p className="homie-products__description">
          Our products use 100% pesticide-free Sweetspot flower, with eco-friendly packaging made from compostable and post-consumer recycled materials.
        </p>

        <div className="homie-products__tabs">
          {categories.map((category, index) => (
            <button
              key={category.id}
              className={getTabClassName(index)}
              onClick={() => setSelectedCategory(category.id)}
            >
              {category.title}
            </button>
          ))}
        </div>

        <div className="homie-products__image-container">
          <img
            src={currentCategory.image}
            alt={currentCategory.title}
            className={`homie-products__image homie-products__image--${currentCategory.id}`}
          />
        </div>
      </div>
    </section>
  );
};

export default HomieProducts;
